module.exports = {"320118001":"淳溪街道","320118002":"古柏街道","320118101":"阳江镇","320118102":"砖墙镇","320118104":"漆桥镇","320118105":"固城镇","320118106":"东坝镇","320118108":"桠溪镇","320118400":"高淳县团结圩良种繁育场","320118401":"高淳县茶叶实验场","320118402":"高淳监狱","320118403":"高淳县傅家坛林场"}


//////////////////
// WEBPACK FOOTER
// ./src/town/320118.json
// module id = 773
// module chunks = 0